
import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import compose from 'recompose/compose';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

import { withRouter } from 'react-router-dom';
import DateTimePicker from 'react-datetime-picker';
import DateTimeRangePicker from '@wojtekmaj/react-datetimerange-picker';
// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import Slider from 'react-dynamic-time-slider'
// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';

// Custom components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Popover from '@material-ui/core/Popover';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

// Component styles
import styles from './styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import AudioElement from './AudioElement'
import Grid from '@material-ui/core/Grid';
import moment from 'moment'
import 'moment/locale/es'
import { AtCircularProgress } from '../../../../components/AtCircularProgress';
import { Box, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { format, sub } from 'date-fns';
import { withTranslation } from 'react-i18next';
moment.locale('es')

class Audios extends Component {
    constructor(props) {
        super(props);
        var nodes=(props.location.state.fromObjective.Nodos)
        var listNodes=[]                                                                                            
        nodes.map(node=>{
            if(node["nodo"]!=='Global'){
                listNodes.push(node)
            }
        })
        this.myCallback = this.myCallback.bind(this);
        var monitores = (props.location.state.fromObjective.Monitores)
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        const erroresList = t('audios.errors', { returnObjects: true });
        this.state = {
            objetive: this.props.match.params.objetivo_id,
            isStatePeriod: false,
            settingsEl: null,
            steps:this.props.location.state.fromObjective.Pasos,
            isRefresh: false,
            isInfo: null,
            nodes:listNodes,
            listMonitores:monitores,
            dateMoment:((moment().locale('es'))),
            dateBefore:moment().subtract({'hours': 1}).locale('es'),
            limit:moment().subtract({'days': 6}).locale('es'),
            limit2:((moment().locale('es'))),
            errors:["", erroresList["0"], erroresList["1"], erroresList["2"], erroresList["3"], erroresList["4"], erroresList["5"]],
            indexError:0,
            isLoad:false,
            extendEl: null,
            nameNodo: t('audios.name-nodo'),
            node: 0,
            begin:moment().subtract({'hours': 1}).locale('es'),
            end:((moment().locale('es'))),
            isLoadButton:false,
            modal:false,
            clockBegin: format(sub(new Date(), {hours: 1}), 'yyyy-MM-dd HH:mm:ss'),
            clockFinal: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
            inputDateMinLimit: format(sub(new Date(), { days: 6 }), 'yyyy-MM-dd HH:mm'),
            inputDateMaxLimit: format(new Date(), 'yyyy-MM-dd HH:mm'),
        };
    }

    myCallback = (dataFromChild) => {
        this.setState({
            isLoadButton:false,
        })
    }

    changeDate=()=>{
        const {clockBegin, clockFinal}=this.state
        const indexError = this.onChange(clockBegin, clockFinal)
        if(indexError === 0){
            this.setState({
                begin:moment(clockBegin),
                end:moment(clockFinal),
                modal:false,
                indexError: 0,
            })
        } else {
            this.setState({
                indexError: indexError,
            })
        }
    }

    handleNextNodeClick = event => {
        const nameNodo = event.currentTarget.name
        const newNode = event.currentTarget.id
        if (this.state.node !== newNode) {
            this.setState({
                node: newNode,
                isLastEvent: false,
                extendEl: null,
                isRefresh: false,
                nameNodo: nameNodo,
            })
        }
    }

    handleShowExtend = event => {
        this.setState({
            extendEl: event.currentTarget
        });
    };
    handleCloseExtend = () => {
        this.setState({
            extendEl: null
        });
    };

    handleShowPop = event => {
        this.setState({
            modal: true
        });
    };
    handleClosePop = () => {
        this.setState({
            modal: false
        });
    };

    handleClose = event => {
        this.props.onClose()
    };
    
    onChange=(clockBegin, clockFinal)=>{
        if(clockBegin.substr(0, 10)!==clockFinal.substr(0, 10)){
            if(this.state.limit>moment(clockBegin)){
                return 1
            }else{
                return 1
            }            
        }else{
            if(moment(clockFinal).unix()-moment(clockBegin).unix()<=0){
                if(moment(clockFinal).unix()-moment(clockBegin).unix()<0){
                    return 3
                }else{
                    return 2
                }
            }else{
                if(this.state.limit2<moment(clockFinal)){
                    return 4
                }else{
                    if(moment(clockFinal).unix()-moment(clockBegin).unix()>3600){
                        return 5
                    }else{
                        return 0
                    }
                }
                
            }
        }
    }


    render() {
        
        const { classes, location } = this.props;
        const {listMonitores, nodes, steps, objetive, dateMoment, dateBefore, isLoad, extendEl, nameNodo, node, limit,
            errors, indexError, limit2, begin, end, isLoadButton, modal} = this.state;
        const showExtendEl = Boolean(extendEl);
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (isLoad===true) {
            return(
                <AtCircularProgress />
            )
        }else{
            return (
                <>
                    <DialogTitle>
                        <Box display='flex' justifyContent='space-between'>
                        <Box display='flex' alignItems='center'>
                            <Typography variant="h4">{t('audios.modal.title')}</Typography>
                            <Button
                                color="primary"
                                variant="text"
                                onClick={this.handleShowExtend}
                                style={{marginLeft: 10}}
                            >
                                {nameNodo} <ArrowRightIcon />
                            </Button>                        
                            <Popover
                                anchorEl={extendEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                    }}
                                onClose={this.handleCloseExtend}
                                open={showExtendEl}
                                >
                                <div className="row1">
                                    <List component="div">
                                        {Object.values(location.state.fromObjective.Nodos).map(i => (
                                            <ListItem
                                                key={i.id_nodo}
                                                className={classes.listItem}
                                                component="div"
                                            >
                                                <Button id={i.id_nodo} name={i.nodo} onClick={(event) => this.handleNextNodeClick(event)}>{i.nodo}</Button> 
                                            </ListItem>))}
                                    </List>
                                </div> 
                            </Popover>
                        </Box>                        
                        <IconButton key="close" aria-label="close" onClick={this.handleClose}><CloseIcon/></IconButton>
                        </Box>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xl={5} lg={5} md={5} sm={12} xs={12}>
                                <TextField
                                    fullWidth
                                    type='datetime-local'
                                    variant='outlined'
                                    size='small'
                                    label={t('text.from')}
                                    InputLabelProps={{shrink: true}}
                                    value={this.state.clockBegin}
                                    onChange={e => this.setState({clockBegin: e.currentTarget.value})}
                                    InputProps={{
                                        inputProps: {
                                            min: this.state.inputDateMinLimit,
                                            max: this.state.inputDateMaxLimit,
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xl={5} lg={5} md={5} sm={12} xs={12}>
                                <TextField
                                    fullWidth
                                    type='datetime-local'
                                    variant='outlined'
                                    size='small'
                                    label={t('text.to')}
                                    InputLabelProps={{shrink: true}}
                                    value={this.state.clockFinal}
                                    onChange={e => this.setState({clockFinal: e.currentTarget.value})}
                                    InputProps={{
                                        inputProps: {
                                            min: this.state.inputDateMinLimit,
                                            max: this.state.inputDateMaxLimit,
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xl={2} lg={2} md={2} sm={12} xs={12} style={{display: 'flex', justifyContent: 'end'}}>
                                <Button color='primary' variant='contained' onClick={this.changeDate.bind(this)} disabled={isLoadButton}>
                                    {t('audios.button.filter')}
                                </Button>
                            </Grid>
                            {errors[indexError] !== "" &&
                                <Grid item xl={12} xs={12}>
                                    <Box>
                                        <Alert severity='error'>
                                            {errors[indexError]}
                                        </Alert>
                                    </Box>
                                </Grid>
                            }
                        </Grid>
                        <Box marginTop={2}>
                        <AudioElement monitors={listMonitores} nodes={nodes} node={node} objective={objetive} steps={steps} 
                            dateBegin={this.state.begin} dateFinal={this.state.end} callbackFromParent={this.myCallback}
                        />
                        </Box>
                    </DialogContent>
                </>
            )        
        }        
    }
}


export default
    compose(withRouter, withStyles(styles), withTranslation())(Audios);